// extracted by mini-css-extract-plugin
module.exports = {"workflowButton":"WorkflowButton_workflowButton__1vpr_"};